import { render, staticRenderFns } from "./ClaimsPublic.vue?vue&type=template&id=04835789"
import script from "./ClaimsPublic.vue?vue&type=script&lang=js"
export * from "./ClaimsPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports